import { render, staticRenderFns } from "./TenderView.vue?vue&type=template&id=16e2d584&scoped=true&"
import script from "./TenderView.vue?vue&type=script&lang=js&"
export * from "./TenderView.vue?vue&type=script&lang=js&"
import style0 from "./TenderView.vue?vue&type=style&index=0&id=16e2d584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2d584",
  null
  
)

export default component.exports